import React, { useState } from "react"

import { Col, Row } from "react-bootstrap"
import InputTextBox from "../input/input-text-box"

const InputDialogModal = props => {
  const [msg, setMsg] = useState("")
  const handleSaveClick = () => {
    if (!!props.searchText) {
      props.onSave(0)
    } else {
      setMsg("Enter something here")
    }
  }

  return (
    <>
      <h1>{props?.searchText?.length >= 0 ? "Save this Search" : "Confirm"}</h1>
      <p className="mb-4">
        {props?.searchText?.length >= 0
          ? "Save this search result for future references."
          : "Are you sure to delete this search history? You cannot undo after deleting."}
      </p>
      <Row>
        <Col lg={12}>
          <InputTextBox
            class={msg && "error"}
            onFocus={() => setMsg("")}
            label="Provide Search Name"
            placeholder="eg.Accountants"
            value={props.searchText}
            onChange={props.onChange}
          />
        </Col>
      </Row>

      <Row>
        <Col lg={12}>
          <button
            type="submit"
            className="btn w-100 btn-custom rounded primary"
            value="  Save and continue"
            onClick={handleSaveClick}
          >
            Save
          </button>
        </Col>
      </Row>
    </>
  )
}

export default InputDialogModal
